<div class="review-modal-overlay" *ngIf="busyService.isBusy$ | async">
  <div class="review-modal-backdrop"></div>
  <div class="review-modal">
    <div class="review-modal-spinner"></div>
    <div class="review-modal-text">
      <p class="review-title">Loading...</p>
      <p class="review-subtitle">Please wait a moment.</p>
    </div>
  </div>
</div>
<!-- <button class="btn btn-sm btn-secondary" (click)="toggle()">
  Toggle Theme
</button> -->
<router-outlet></router-outlet>